import React from 'react'

interface DataPointNodeProps {
  data: {
    color: string
    selected?: boolean
    label?: string
    hasSelection?: boolean
  }
}

const DataPointNode: React.FC<DataPointNodeProps> = ({ data }) => {
  const hasSelection = data.hasSelection || false
  const isSelected = data.selected || false
  const shouldDim = hasSelection && !isSelected

  return (
    <div
      style={{
        width: isSelected ? 12 : 8,
        height: isSelected ? 12 : 8,
        borderRadius: '50%',
        backgroundColor: data.color,
        border: isSelected ? '3px solid #fbbf24' : '1px solid rgba(255, 255, 255, 0.8)',
        cursor: 'pointer',
        boxShadow: isSelected
          ? '0 0 16px rgba(251, 191, 36, 1), 0 0 8px rgba(251, 191, 36, 0.6)'
          : '0 1px 3px rgba(0, 0, 0, 0.3)',
        transition: 'all 0.2s ease',
        transform: isSelected ? 'scale(1.3)' : 'scale(1)',
        zIndex: isSelected ? 1000 : 1,
        position: 'relative',
        opacity: shouldDim ? 0.2 : 1,
        filter: shouldDim ? 'grayscale(50%)' : 'none',
      }}
      title={data.label}
    />
  )
}

export default DataPointNode
